import * as gql from "gql-query-builder";

const taskDefinitionRecordQueryFields = [
    {
        records: [
            "id",
            "status",
            "totalRecords",
            "processedRecords",
            "successRecords",
            "failedRecords",
            {
                TaskDefinitionRecordTracksExportedFile: [
                    "relationsCount",
                    {
                        relations: [
                            "id",
                            {
                                record: ["id", "name"],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    "recordsCount",
];

export const taskDefinitionRecordQuery = (taskDefinitionRecordId: number) => {
    return gql.query({
        operation: "TaskDefinitionRecord",
        variables: {
            filter: {
                value: {
                    id: {
                        equal: taskDefinitionRecordId,
                    },
                },
                type: "TaskDefinitionRecordFilterInput",
            },
        },
        fields: taskDefinitionRecordQueryFields,
    });
};
